export default class WidgetInitialSettings {
    public tlaCid: string = '';

    public propertyId: number = 0;

    public zoneId: string = '';

    public contentSetVersionId: number = 0;

    public contentId: number = 0;
}
